<template>
    <aside class="contact-box" :class="rootClasses">
        <div class="contact-box--container">
            <div class="contact-box--content-wrapper">
                <slot/>
            </div>
        </div>
    </aside>
</template>

<script>
    import { elementOffsetTop } from 'bianco.viewport';
    import { mapState } from 'vuex';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        mixins: [bemMixin('contact-box')],
        data() {
            return {
                isSticky: false,
            };
        },
        computed: {
            ...mapState('vue-ui/scroll', {
                scrollPosition: 'position',
            }),
            rootClasses() {
                return [
                    this.bemIf(this.isSticky, 'sticky', 'base'),
                ];
            },
        },
        methods: {
            checkIsSticky() {
                this.isSticky = this.scrollPosition > elementOffsetTop(this.$el);
            },
        },
        watch: {
            scrollPosition() {
                this.checkIsSticky();
            },
        },
        mounted() {
            this.checkIsSticky();
        },
    };
</script>
